(function() {
/**
 * This file contains the JS needed for any pv web components.
 */
class FigureDetails extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('details').forEach(detail => {
      detail.querySelector('summary').addEventListener('click', () => {
        // Close other details inside this FigureDetails
        this.querySelectorAll('details').forEach(d => {
          if (d !== detail) {
            d.removeAttribute('open');
          }
        });
        // Change image source for this FigureDetails
        const imageSrc = detail.dataset.imageUrl;
        this.querySelector('pv-figure-details img').src = imageSrc;
      });
    });
  }
}
customElements.define("pv-figure-details", FigureDetails);

// This component adds support for auto-close on pv-dropdown/pv-multi-select classes
class PVDropdownAutoClose extends HTMLElement {
    constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.handleDropdownSelected = this.handleDropdownSelected.bind(this);
        this.lastOpenedElement = null;
    }
  
    connectedCallback() {
        document.addEventListener('click', this.handleClick);
        this.addEventListener('click', this.handleDropdownSelected);
    }
  
    disconnectedCallback() {
        document.removeEventListener('click', this.handleClick);
        this.removeEventListener('click', this.handleDropdownSelected);
    }
  
    handleDropdownSelected(event) {
        this.lastOpenedElement = event.target;
    }
  
    handleClick(event) {
        // Check to make sure we aren't closing a new dropdown being opened, otherwise close it
        if (this.lastOpenedElement && event.target !== this.lastOpenedElement) {
            const dropdownElement= this.querySelector('.pv-select-multiple, [class*="pv-button"]');
            dropdownElement.removeAttribute('data-dropdown');
        }
    }
  }
  customElements.define('pv-dropdown-auto-close', PVDropdownAutoClose);

// A generic auto-close component
class PVAutoClose extends HTMLElement {
    constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.handleSelected = this.handleSelected.bind(this);
        this.lastOpenedElement = null;
        this.closeableElement = this.querySelector('.pv-auto-close-content');
    }

    connectedCallback() {
        this.closeableElement.classList.add('pv-hide');
        document.addEventListener('click', this.handleClick);
        this.addEventListener('click', this.handleSelected);
    }

    disconnectedCallback() {
        document.removeEventListener('click', this.handleClick);
        this.removeEventListener('click', this.handleSelected);
    }

    handleSelected(event) {
        // close the element if the user clicks on anything but the closeable element itself, otherwise open it or keep it open
        const isCloseableElement = event.target.closest('.pv-auto-close-content') === this.closeableElement;
        if (!isCloseableElement && !this.closeableElement.classList.contains('pv-hide')) {
            this.closeableElement.classList.add('pv-hide');
        }
        else {
            this.lastOpenedElement = event.target;
            this.closeableElement.classList.remove('pv-hide');
        }
    }

    handleClick(event) {
        // Check to make sure we aren't closing a new dropdown being opened, otherwise close it
        if (this.lastOpenedElement && event.target !== this.lastOpenedElement) {
            this.closeableElement.classList.add('pv-hide');
        }
    }
  }
  customElements.define('pv-auto-close', PVAutoClose);

    class PvDataGridLoadingOverlay  {
        eGui;

        init(params) {
            this.eGui = document.createElement('div');
            this.refresh(params);
        }

        getGui() {
            return this.eGui;
        }

        refresh(params) {
            const loadingImgSrc = params.loadingImgSrc;
            this.eGui.innerHTML = `<div class="ag-overlay-loading-center" role="presentation" style="border: 0;">
            <div role="presentation" style="height:100px; width:100px; margin: 0 auto;">
                <img src="${loadingImgSrc}" alt="Loading" style="width: 100%; height: 100%; object-fit: contain;" />
            </div>
         </div>`;
        }
    }

    // This component adds a pv-styled data-grid
    class PVDataGrid extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            // Read the `img-src` attribute from the component tag
            this.loadingImgSrc = this.getAttribute('loading-img-src');
            if (!this.loadingImgSrc) {
                throw new Error('loading-img-src attribute not specified for pv-data-grid');
            }
        }

        createGrid(additionalGridOptions, enableRowSpanning = false) {
            this.initializeGridOptions(additionalGridOptions, enableRowSpanning);
            return agGrid.createGrid(this, this.gridOptions);
        }

        defaultValueFormatter(params) {
            const colId = params.colDef.field;
            return params.data[colId] || "-";
        }

        initializeGridOptions(additionalOptions = {}, enableRowSpanning= false) {
            const pvBaseGridOptions = {
                defaultColDef: {
                    sortable: false,
                    suppressHeaderMenuButton: true,
                    unSortIcon: true,
                    valueFormatter: this.defaultValueFormatter,
                },
                loadingOverlayComponent: PvDataGridLoadingOverlay,
                loadingOverlayComponentParams: {
                    loadingImgSrc: this.loadingImgSrc,
                },
                theme: "legacy",
                animateRows: false,
                tooltipShowDelay: 0,
                tooltipHideDelay: 5000,
                suppressDragLeaveHidesColumns: true,
                suppressContextMenu: true,
                suppressColumnVirtualisation: true,
                suppressRowVirtualisation: true,
            };

            // if we're using rowSpan, disable the row borders and apply them manually, so
            if (enableRowSpanning) {
                pvBaseGridOptions.rowStyle = { border: 'none' };
                pvBaseGridOptions.defaultColDef.cellClassRules = {
                    "data-grid-cell-bottom-border": () => true,
                }
            }

            // Merge the base options with the additional options
            this.gridOptions = Object.assign({}, pvBaseGridOptions, additionalOptions);
        }

    }
    customElements.define('pv-data-grid', PVDataGrid);
})();